module.exports = __webpack_public_path__ + "img/tequila_sunrise.7233a734.jpg";